import styled from "styled-components";

export const Main = styled.main`
	padding: 20px;
	max-width: 1400px;
	margin: 0 auto;
`;
